<template>
  <page>
    {{ $t('cms.Forbidden') }}
  </page>
</template>

<script>
export default {
  name: 'forbidden',
};
</script>
